/**
 * Set the item cache in LocalStorage.
 *
 * @param key - The key of the item in LocalStorage.
 * @param data - Cached data of type T.
 */
export const setCached = <T>(key: string, data: T): void => {
	window.localStorage.setItem(key, JSON.stringify(data));
};
